const closeVideoDialog = () => {
    const  btnClose = document.querySelector('#btn-close-video'),
        media = document.querySelector('.nt-video vds-media video');

    btnClose.addEventListener('click', () => {
        media.pause()
    })
}

$(closeVideoDialog())